export function Toaster() {
  return null; // más adelante se puede integrar la librería real
}